import { render, staticRenderFns } from "./TopTagList.vue?vue&type=template&id=70c3143e"
import script from "./TopTagList.vue?vue&type=script&setup=true&lang=js"
export * from "./TopTagList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports